import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Badge } from "../ui/badge";

const TESTIMONIALS = [
  {
    name: "Sarah Chen",
    role: "Marketing Director",
    company: "TechFlow Inc.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    quote: "YASNO cut our content creation time by 85%. What used to take a week now takes hours.",
    metric: "85% faster",
    metricColor: "bg-primary/20 text-primary"
  },
  {
    name: "Ahmed Al-Rashid",
    role: "CEO",
    company: "Dubai Digital Agency",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    quote: "Finally, a platform that truly understands Arabic marketing. The cultural nuances are spot-on.",
    metric: "300% more engagement",
    metricColor: "bg-green-500/20 text-green-400"
  },
  {
    name: "Maria Garcia",
    role: "Social Media Manager",
    company: "Global Brands Co.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    quote: "Managing 12 client accounts went from chaos to autopilot. The ROI speaks for itself.",
    metric: "$50K saved/month",
    metricColor: "bg-primary/20 text-primary"
  },
  {
    name: "James Wilson",
    role: "Founder",
    company: "StartupLaunch",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
    quote: "I just speak what I want, and YASNO handles everything. It's like having a CMO on demand.",
    metric: "10x content output",
    metricColor: "bg-green-500/20 text-green-400"
  }
];

/**
 * TestimonialsSection Component - EXACT ORIGINAL DESIGN
 */
export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-4"
        >
          <Badge className="mb-4 bg-primary/20 text-primary border-primary/30">
            Testimonials
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4" data-testid="testimonials-title">
            Loved by Marketing Teams Worldwide
          </h2>
          <p className="text-muted-foreground text-lg mb-12">
            Join thousands of marketers who've transformed their workflow with YASNO
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {TESTIMONIALS.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card rounded-2xl p-6 border border-white/10 hover:border-primary/30 transition-all"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote */}
              <p className="text-lg mb-6 leading-relaxed">
                "{testimonial.quote}"
              </p>

              {/* Author Row */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <p className="font-semibold">{testimonial.name}</p>
                    <p className="text-sm text-muted-foreground">
                      {testimonial.role}, {testimonial.company}
                    </p>
                  </div>
                </div>
                <Badge className={`${testimonial.metricColor} border-0`}>
                  {testimonial.metric}
                </Badge>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Active Agents Counter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-green-500/10 border border-green-500/30">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
            <span className="text-green-400">
              <strong>1,245</strong> Agents are currently creating content
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
